export default __webpack_public_path__ + "static/media/for-players-cv.141d5f85.svg";